import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { navLinks, siteInfo } from "@/mocks/site";

export default function SiteHeader() {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const isActive = (href: string) => {
    if (href === "/") return location.pathname === "/";
    if (href.startsWith("/archive")) return location.pathname.startsWith("/archive");
    return location.pathname.startsWith(href);
  };

  return (
    <header className="w-full">
      <div className="bg-primary-950 text-background-100">
        <div className="flex items-center justify-between gap-4 px-4 md:px-8 h-9 text-[11px] md:text-xs">
          <p className="flex items-center gap-2 truncate">
            <span className="inline-flex w-2 h-2 items-center justify-center">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-live-dot" />
            </span>
            <span className="truncate">编辑部今日更新 3 条档案 · 证据链持续补充中</span>
          </p>
          <div className="hidden sm:flex items-center gap-5 shrink-0">
            <span className="hidden md:inline text-background-100/70">2026.09.10</span>
            <a href={`mailto:${siteInfo.tipsEmail}`} className="hover:text-accent-300 transition-colors cursor-pointer">
              <i className="ri-mail-send-line mr-1" />线索投递
            </a>
          </div>
        </div>
      </div>

      <div className="sticky top-0 z-50 border-b border-background-200 bg-background-50/95 backdrop-blur">
        <div className="flex items-center justify-between gap-4 px-4 md:px-8 h-16">
          <Link to="/" className="flex items-center gap-3 shrink-0 cursor-pointer">
            <span className="flex w-10 h-10 items-center justify-center rounded-md bg-primary-500 text-background-50 font-heading text-xl font-bold">
              瓜
            </span>
            <span className="flex flex-col leading-tight">
              <span className="font-heading text-lg md:text-xl font-bold tracking-wide text-foreground-950">
                {siteInfo.name}
              </span>
              <span className="hidden sm:block text-[11px] text-foreground-500 tracking-widest">
                {siteInfo.slogans}
              </span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-3.5 py-2 rounded-md text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  isActive(link.href)
                    ? "bg-primary-100 text-primary-800 font-medium"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2 shrink-0">
            <Link
              to="/archive#tips"
              className="hidden sm:inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-megaphone-line" />
              我要爆料
            </Link>
            <button
              type="button"
              aria-label="展开导航菜单"
              aria-expanded={open}
              onClick={() => setOpen((v) => !v)}
              className="lg:hidden flex w-10 h-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"} />
            </button>
          </div>
        </div>

        {open && (
          <nav className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-3" aria-label="移动导航">
            <ul className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className={`block px-3 py-2.5 rounded-md text-sm transition-colors cursor-pointer ${
                      isActive(link.href)
                        ? "bg-primary-100 text-primary-800 font-medium"
                        : "text-foreground-700 hover:bg-background-100"
                    }`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <Link
              to="/archive#tips"
              className="mt-2 flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-megaphone-line" />
              我要爆料
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
}